import axios from "axios";
import React, {Component} from "react";
import SchoolfeecategoryForm from "./SchoolfeecategoryForm";
import FeatherIcon from 'feather-icons-react';
import SectionschoolfeecategoryForm from "./SectionschoolfeecategoryForm";
import SectionschoolfeecategorystudentcategoryForm from "./SectionschoolfeecategorystudentcategoryForm";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

class   Schoolfeecategory extends Component{

    state = {
        isModal : false,
        loading : true,
        formData : null,
        formDataStudent : null,
        formDataSection : null,
        formDataSectionItem : null,
        formdataCategory : null,
        formDataSectionStudent : null,
        modalSectionStudent : false,
        modalSection : false,
        schoolfeecategories : [],
        isModalTransport : false,
        idtransport : null,
        axe : "",
        transports : [],
        sections : [],
        error : "",
    }

    componentDidMount(){
        this.getSchoolfeecategories();
        this.getSections();
        this.getTransports();
    }

    async getSchoolfeecategories(){
        this.setState({schoolfeecategories : [], loading : false})
        var schoolfeecategories = await axios.get('schoolfeecategories');
        if(schoolfeecategories.status === 200)
        {
            this.setState({schoolfeecategories : schoolfeecategories.data, loading : true}) 
        }
    }

    async getSections(){
        var sections = await axios.get('sections');
        if(sections.status === 200)
        {
            this.setState({sections : sections.data }) 
        }
    }

    async getTransports(){
        var transports = await axios.get('transports');
        if(transports.status === 200)
        {
            this.setState({transports : transports.data }) 
        }
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    storeTransport  = () =>{
        var data = { 
            axe : this.state.axe 
        }
        
        var request = this.state.idtransport ? axios.put('transports/'+this.state.idtransport, data) : axios.post('transports', data);
        request.then((response) =>{
            this.showModalTransport()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }
    showModalTransport = (transport = null) => {
        this.setState({
            isModalTransport : !this.state.isModalTransport,
            axe : transport ? transport.axe : transport,
            idtransport : transport ? transport.id : transport,
        })
        if(!this.state.isModalTransport)
            this.getTransports()
    }

    showModal = (schoolfeecategory = null) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : schoolfeecategory,
        })
        if(!this.state.isModal)
            this.getSchoolfeecategories()
    }

    showModalSection = (schoolfeecategory = null, sectionschoolfeecategory = null) => {
        const isClosing = this.state.modalSection;
        this.setState({
            modalSection : !this.state.modalSection,
            formDataSection : schoolfeecategory,
            formDataSectionItem : sectionschoolfeecategory
        }, () => {
            if(isClosing)
                this.getSchoolfeecategories()
        })
    }

    showModalSectionStudent = (schoolfeecategorysection = null, category = null) => {
        this.setState({
            modalSectionStudent : !this.state.modalSectionStudent,
            formDataSectionStudent : schoolfeecategorysection,
            formdataCategory : category
        })
        if(!this.state.modalSectionStudent)
            this.getSchoolfeecategories()
    }

    delete = (schoolfeecategory) =>{
        axios.delete("schoolfeecategories/"+schoolfeecategory).then((response) => {
            this.getSchoolfeecategories()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    deleteTransport = (transport) =>{
        axios.delete("transports/"+transport).then((response) => {
            this.getTransports()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    deleteEst = (sectionschoolfeecategory) => {
        axios.delete("sectionschoolfeecategories/"+sectionschoolfeecategory).then((response) => {
            this.getSchoolfeecategories()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        }) 
    }

    deletesectschoolfeecatstudentcat = (sectschoolfeecatstudentcat) => {
        axios.delete("estsectschoolcatstudcats/"+sectschoolfeecatstudentcat).then((response) => {
            this.getSchoolfeecategories()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        }) 
    }

    handleCheck(val) {
        var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
        return permissions.some(item => val === item.permission);
    }

    deleteChartaccoutPrice = (val) => {
        axios.delete("chartaccountpurcents/"+val).then((response) => {
            this.getSchoolfeecategories()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    renderCategoryCard = (schoolfeecategory) => (
        <article className="schoolfee-config-card" key={schoolfeecategory?.id}>
            <div className="schoolfee-config-card__header">
                <div>
                    <span>Type de paiement</span>
                    <h2>{schoolfeecategory?.category}</h2>
                </div>
                <button type="button" className="btn btn-sm btn-outline-primary schoolfee-config-action" onClick={() => this.showModalSection(schoolfeecategory)}><FeatherIcon icon="plus-circle" size={15} /> Section</button>
            </div>

            <div className="schoolfee-config-card__body">
                <div className="schoolfee-config-rows">
                    {(schoolfeecategory?.sectionschoolfeecategories || [])?.map((sectionschoolfeecategory) => (
                        <div className="schoolfee-config-row" key={sectionschoolfeecategory.id}>
                            <div className="schoolfee-config-row__main">
                                <span className="schoolfee-config-mark"><FeatherIcon icon={sectionschoolfeecategory.transport ? "truck" : "layers"} size={13} /></span>
                                <div className="schoolfee-config-row__title">
                                    <strong>{ sectionschoolfeecategory.transport ? sectionschoolfeecategory.transport.axe : sectionschoolfeecategory.section.entitled_section }</strong>
                                    <small>{ sectionschoolfeecategory.transport ? "Axe transport" : "Section scolaire" }</small> <small className="text-small text-primary">{ sectionschoolfeecategory.year?.year }</small>
                                </div>
                            </div>
                            <div className="schoolfee-config-row__price">{ sectionschoolfeecategory.price?.toLocaleString() + "" + sectionschoolfeecategory.currency }</div>
                            <span className="schoolfee-config-status">{ sectionschoolfeecategory.status }</span>
                            <div className="schoolfee-config-row-actions">
                                {this.handleCheck("Modifier type de paiement") === true && <button onClick={ () => this.showModalSection(schoolfeecategory, sectionschoolfeecategory)} className="schoolfee-config-icon text-primary" title="Modifier cet enregistrement"><FeatherIcon icon="edit-3" size={12} /> </button>}
                                {sectionschoolfeecategory.status == "Actif" && this.handleCheck("Supprimer type de paiement") == true && <button onClick={ () => this.deleteEst(sectionschoolfeecategory.id)} className="schoolfee-config-icon text-danger" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="delete" size={12} /> </button>}
                            </div>
                            {(sectionschoolfeecategory.chartaccountpurcents?.filter(va => va.purcent > 0)?.length > 0 || sectionschoolfeecategory.trimesectschools?.filter(va => va.price > 0)?.length > 0) && (
                                <div className="schoolfee-config-tags schoolfee-config-row__meta">
                                    {sectionschoolfeecategory.chartaccountpurcents?.filter(va => va.purcent > 0)?.map((chartaccount) => <span key={chartaccount.id || chartaccount.chartaccountId || chartaccount.chartaccount?.wording}>{ chartaccount.chartaccount?.wording } { chartaccount.purcent }%</span>)}
                                    {sectionschoolfeecategory.trimesectschools?.filter(va => va.price > 0)?.sort((a, b) => a.trimester?.id - b.trimester?.id)?.map((trime) => <span key={trime.id || trime.trimesterId || trime?.trimester?.trimester}><i>{ trime?.trimester?.short_trimester } { trime.price?.toLocaleString() }{sectionschoolfeecategory.currency}</i></span>)}
                                </div>
                            )}
                            {sectionschoolfeecategory.sectschoolfeecatstudentcats.length > 0 && (
                                <div className="schoolfee-config-students">
                                    {sectionschoolfeecategory.sectschoolfeecatstudentcats.map((sectschoolfeecatstudentcat) => (
                                        <span className="schoolfee-config-student" key={sectschoolfeecatstudentcat.id}>
                                            <b>{sectschoolfeecatstudentcat.category_student}</b>
                                            {sectschoolfeecatstudentcat.price + "" + sectionschoolfeecategory.currency }
                                            {sectschoolfeecatstudentcat.status == "Actif" && this.handleCheck("Supprimer type de paiement") == true && <button onClick={ () => this.deletesectschoolfeecatstudentcat(sectschoolfeecatstudentcat.id)} className="schoolfee-config-mini-delete" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="x" size={10} /> </button>}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                {(schoolfeecategory.sectionschoolfeecategories || [])?.length === 0 && <div className="schoolfee-config-empty"><FeatherIcon icon="inbox" size={15} /> Aucune section attachee.</div>}
                <div className="schoolfee-config-card__footer">{schoolfeecategory.operation}</div>
            </div>
        </article>
    )

    render(){
        const categoryCount = this.state.schoolfeecategories.length;
        const sectionCount = this.state.sections.length;
        const transportCount = this.state.transports.length;
        const schoolfeecategories = this.state.schoolfeecategories.map(this.renderCategoryCard);

        return(
            <main className="schoolfee-config-page ev-page">
                <header className="ev-page-header schoolfee-category-header">
                    <div className="ev-page-header__content">
                        <span className="ev-page-header__eyebrow">Comptabilite scolaire</span>
                        <h1>Types des paiements</h1>
                        <p>Configurez les categories, les sections, les axes de transport et la repartition des frais.</p>
                    </div>
                    <div className="ev-page-header__actions schoolfee-category-stats">
                        <span><FeatherIcon icon="credit-card" size={16} /> {categoryCount} type(s)</span>
                        <span><FeatherIcon icon="layers" size={16} /> {sectionCount} section(s)</span>
                        <span><FeatherIcon icon="truck" size={16} /> {transportCount} axe(s)</span>
                        {this.handleCheck("Ajouter type de paiement") == true && <button type="button" className="btn btn-sm btn-outline-primary schoolfee-config-action" onClick={() => this.showModal(null)}><FeatherIcon icon="plus-circle" size={15} /> Type de paiement</button>}
                    </div>
                </header>

                <div className="schoolfee-config-layout">
                    <section className="schoolfee-config-main ev-page-section">
                        <div className="ev-page-section__header">
                            <div>
                                <span className="schoolfee-config-kicker">Parametrage</span>
                                <h2>Categories et affectations</h2>
                            </div>
                            <FeatherIcon icon="settings" size={18} />
                        </div>
                        <div className="schoolfee-config-grid">
                            { this.state.loading ? (schoolfeecategories.length ? schoolfeecategories : <div className="schoolfee-category-state"><FeatherIcon icon="inbox" /><span>Aucun type de paiement enregistre.</span></div>) : <div className="schoolfee-category-state"><FeatherIcon className="user-search-spin" icon="loader" /><span>Chargement des types de paiement...</span></div>}
                        </div>
                    </section>

                    <aside className="schoolfee-config-sidebar">
                        <section className="schoolfee-config-side-card">
                            <div className="schoolfee-config-side-card__header">
                                <span><FeatherIcon icon="credit-card" size={15} /></span>
                                <h3>Paiement</h3>
                            </div>
                            <div className="schoolfee-config-list-">
                                {this.state.schoolfeecategories.map((schoolfeecategory) => (
                                    <div className="schoolfee-config-list-item" key={schoolfeecategory.id}>
                                        <div className="schoolfee-config-list-item__title"><FeatherIcon icon="chevrons-right" size={14} />{ schoolfeecategory.category}</div>
                                        <div className="schoolfee-config-row-actions">
                                            {this.handleCheck("Modifier paiement") == true && <button onClick={ () => this.showModal(schoolfeecategory)} className="schoolfee-config-icon text-primary" title="Modifier cet enregistrement"><FeatherIcon icon="edit-3" size={13} /> </button>}
                                            {this.handleCheck("Supprimer paiement") == true && <button onClick={ () => this.delete(schoolfeecategory.id)} className="schoolfee-config-icon text-danger" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="delete" size={13} /> </button>}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>

                        <section className="schoolfee-config-side-card">
                            <div className="schoolfee-config-side-card__header">
                                <span><FeatherIcon icon="layers" size={15} /></span>
                                <h3>Section</h3>
                            </div>
                            <div className="schoolfee-config-list-">
                                {this.state.sections.map((section) => (
                                    <div className="schoolfee-config-list-item" style={{ padding: 4, margin : 2}} key={section.id}>
                                        <div className="schoolfee-config-list-item__title"><FeatherIcon icon="box" size={14} /><span>{ section.entitled_section}</span></div>
                                        <strong>{ section.short_entitled_section}</strong>
                                    </div>
                                ))}
                            </div>
                        </section>
                    
                        <section className="schoolfee-config-side-card">
                            <div className="schoolfee-config-side-card__header">
                                <span><FeatherIcon icon="truck" size={15} /></span>
                                <h3>Transport</h3>
                                {this.handleCheck("Ajouter type de paiement") == true && <button type="button" className="schoolfee-config-icon text-primary ms-auto" onClick={() => this.showModalTransport(null)}><FeatherIcon icon="plus" size={14} /> </button>}
                            </div>
                            <div className="schoolfee-config-list-">
                                {this.state.transports.map((transport) => (
                                    <div className="schoolfee-config-list-item" key={transport.id}>
                                        <div className="schoolfee-config-list-item__title"><FeatherIcon icon="chevrons-right" size={14} /><span>{ transport.axe}</span></div>
                                        <div className="schoolfee-config-row-actions">
                                            {this.handleCheck("Modifier type de paiement") === true && <button onClick={ () => this.showModalTransport(transport)} className="schoolfee-config-icon text-primary" title="Modifier cet enregistrement"><FeatherIcon icon="edit-3" size={13} /> </button>}
                                            {this.handleCheck("Supprimer type de paiement") == true && <button onClick={ () => this.deleteTransport(transport.id)} className="schoolfee-config-icon text-danger" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="delete" size={13} /> </button>}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </aside>
                </div>

                <SchoolfeecategoryForm isModal={this.state.isModal} formData={this.state.formData} showModal={this.showModal} />

                {this.state.modalSection && <SectionschoolfeecategoryForm isModal={this.state.modalSection} formData={this.state.formDataSection} sectionData={this.state.formDataSectionItem} showModal={this.showModalSection} />}

                {this.state.isModalTransport && (
                    <Modal show={this.state.isModalTransport} onHide={this.isModalTransport} size="lg" contentClassName="ev-form-modal ev-form-modal--compact" backdrop={"static"}>
                        <Modal.Header>
                            <div className="student-form__heading">
                                <span className="student-form__heading-icon"><FeatherIcon icon="truck" size={18} /></span>
                                <div>
                                    <span className="student-form__eyebrow">Transport</span>
                                    <Modal.Title>Transport</Modal.Title>
                                </div>
                            </div>
                        </Modal.Header>
                        <Modal.Body className="row ev-form-body">
                            <span className="text-danger text-small small">{ this.state.error }</span>
                            <div className="col-md-12 mt-2 mt-2">
                                <div className="form-group has-icon-left">
                                    <label htmlFor="nom-id-icon">Axe</label>
                                    <div className="position-relative mt-1">
                                        <input type="text" className="form-control form-control-sm" onChange={this.handleInput} name="axe" value={this.state.axe} id="nom-id-icon" />
                                        <div className="form-control-icon"><FeatherIcon icon="activity" /></div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <span className="ev-form-footer-note"><FeatherIcon icon="info" size={13} /> Parametrage des axes de transport</span>
                            <button onClick={() => this.showModalTransport()} className="btn btn-light ev-form-button"><FeatherIcon icon="corner-down-left" /> Fermer</button>
                            <button onClick={() => this.storeTransport()} className="btn btn-primary ev-form-button"><FeatherIcon icon="check-square" /> Sauvegarder</button>
                        </Modal.Footer>
                    </Modal>
                )}

                {this.state.modalSectionStudent && <SectionschoolfeecategorystudentcategoryForm isModal={this.state.modalSectionStudent} formData={this.state.formDataSectionStudent} category={this.state.formdataCategory} showModal={this.showModalSectionStudent} />}
            </main>
        )
    }
}
export default Schoolfeecategory;
